import type { AxiosError } from 'axios';
import { createJsonApiClient } from '@/js/lib/http/create-json-api-client';
import {
  attachCsrfRetryInterceptor,
  writeCsrfToken,
} from '@/js/lib/http/csrf';

export { isValidationError } from '@/js/lib/http/errors';

export const accountHttp = createJsonApiClient({
  baseURL: '/api/account',
});

export async function refreshAccountCsrfToken(): Promise<string> {
  const { data } = await accountHttp.get<{ csrfToken: string }>('/csrf');
  writeCsrfToken(data.csrfToken);
  return data.csrfToken;
}

attachCsrfRetryInterceptor(accountHttp, refreshAccountCsrfToken);

let unauthorizedHandler: (() => void) | null = null;

export function setAccountUnauthorizedHandler(
  handler: (() => void) | null,
): void {
  unauthorizedHandler = handler;
}

function isSessionProbeRequest(error: AxiosError): boolean {
  if (error.config?.method?.toLowerCase() !== 'get') {
    return false;
  }

  const path = (error.config.url ?? '').split('?')[0];

  return path === '/me';
}

accountHttp.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401 && !isSessionProbeRequest(error)) {
      // Defer so Vue is not mid-patch when auth layout tears down.
      queueMicrotask(() => unauthorizedHandler?.());
    }

    return Promise.reject(error);
  },
);
